import React, { useContext, useEffect, useState } from 'react';
import { Header, Page, PageAuth, PageHeader, PERMISSIONS, Sidebar, SideMenu, PageContainer, GlobalAlert } from '../..';
import { gamesPages, useStore } from '../../../common';
import { Button, Modal, Pagination, PlusLight, Table } from 'esa-ui-library';
import styles from './GameCategories.module.scss';
import { AuthContext } from '../../../logic';
import { PropertyType } from 'esa-ui-library/lib/types';
import { getRows } from './RowProvider';
import { gameCategoriesListMap } from './GameCategories.const';
import { SAVE } from '../GamblingReport/ReportTemplates/ReportTemplates.const';
import { CreateGameCategoryForm } from './components/CreateGameCategoryForm';

const GameCategories = (): JSX.Element => {
	const [state, dispatch] = useStore();
	const [loading, setLoading] = useState(false);
	const {
		gameCategories,
		rows,
		bulkRows,
		columns,
		pagesTotal,
		currentPage,
		gameCategoriesLoading,
		perPage = '10',
		selectedGameCategory,
		gameCategoryForm,
	} = state;
	const { user, token } = useContext(AuthContext);
	const [editModal, setEditModal] = useState(false);
	const filteredGameCategoriesFields = gameCategoriesListMap;

	const setColumnsConfig = (columns: PropertyType[]) =>
		columns.map((c) => {
			return {
				...c,
				cellClassName: c.position ? styles[c.position] : '',
			};
		});

	const addBulkAll = () => {
		return [
			// <Checkbox
			// 	disabled
			// 	key={uuid()}
			// 	checked={allRowsSelected}
			// 	partial={!!bulkRows.length && !allRowsSelected}
			// 	onChange={onBulkAllChange}
			// 	dataId='bulk-check'
			// />,
			...setColumnsConfig(filteredGameCategoriesFields),
			'',
		];
	};

	const onAction = (type: string, gameCategory: PropertyType) => {
		switch (type) {
			case 'edit':
				dispatch('SELECT_GAME_CATEGORY', { gameCategory });
				setEditModal(true);
				break;
			default:
				break;
		}
	};

	useEffect(() => {
		dispatch('LOADING', false);
		dispatch('GAME_CATEGORIES_INIT', { token, currentPage, perPage });
	}, []);

	const onPageChange = (page: number | string) => {
		dispatch('LOADING', true);
		dispatch('PAGE_UPDATE', { token, page, perPage });
	};

	useEffect(() => {
		dispatch('UPDATE_COLUMNS', addBulkAll());
	}, [gameCategories, bulkRows]);

	useEffect(() => {
		dispatch('UPDATE_ROWS', getRows(gameCategories, columns, onAction));
	}, [gameCategories, columns]);

	const onPerPageChange = (value: PropertyType) => {
		const perPage = value[0].value;
		dispatch('LOADING', true);
		dispatch('PER_PAGE', perPage);
		dispatch('PAGE_UPDATE', { token, currentPage, perPage });
	};

	const onAddGameCategory = () => {
		setEditModal(true);
	};

	const onCloseCreateModal = () => {
		setEditModal(false);
		dispatch('SELECT_GAME_CATEGORY', { game: null });
		dispatch('FORM_RESET');
		dispatch('MESSAGE_INVALIDATE');
	};

	const onSubmit = async () => {
		setLoading(true);
		await dispatch('GAME_CATEGORY_ADD', { token, gameCategoryForm });
		setEditModal(false);
		dispatch('FORM_RESET');
		setLoading(false);
	};

	return (
		<>
			<Header dataId='header' />
			<PageAuth onlyAdmin permission={PERMISSIONS.canListGames}>
				<PageContainer>
					<Sidebar dataId='admin-sidebar'>
						<SideMenu options={gamesPages} title='Game Categories' />
					</Sidebar>
					<Page>
						<PageHeader title='Casino Game Categories'>
							{user?.permissions?.isSuperAdmin ? (
								<Button dataId='create-user' primary small onClick={onAddGameCategory}>
									<PlusLight className={styles.AddUserIcon} />
									Create Game Category
								</Button>
							) : null}
						</PageHeader>
						<section className={styles.PageContent}>
							{(!!gameCategories?.length || gameCategoriesLoading) && (
								<>
									<Table
										titles={columns}
										data={rows}
										className={styles.GameCategoriesTable}
										rowClassName={styles.GameCategoriesRow}
										isLoading={gameCategoriesLoading}
									/>
									<Pagination
										total={Math.ceil(pagesTotal / +perPage)}
										current={currentPage}
										onChange={onPageChange}
										perPage={perPage}
										showPerPage
										onPerPage={onPerPageChange}
									/>
								</>
							)}
							{editModal && (
								<Modal
									title={selectedGameCategory ? 'Edit Game Category' : 'Create Game Category'}
									submitLabel={SAVE}
									primary
									onCancel={onCloseCreateModal}
									onSubmit={onSubmit}
									loading={loading}
								>
									<CreateGameCategoryForm isEdit={!!selectedGameCategory} />
								</Modal>
							)}
						</section>
					</Page>
				</PageContainer>
				<GlobalAlert />
			</PageAuth>
		</>
	);
};

export { GameCategories };
